import { AxiosResponse } from 'axios';
import useAxiosInterceptor from './useAxiosInterceptor';

// Custom hook for API service
export const useApiService = () => {

    const axiosInstance = useAxiosInterceptor();

    // POST request without authorization (public)
    const postPublicRequest = async (
        urlEndPoint: string,
        data: any
    ): Promise<AxiosResponse> => {
        return axiosInstance.post(urlEndPoint, data, {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
            }
        });
    };

    // GET request without authorization (public)
    const fetchPublicRequest = async (
        urlEndPoint: string,
        data?: any
    ): Promise<AxiosResponse> => {
        return axiosInstance.get(urlEndPoint, {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
            params: data,
        });
    };

    return {
        postPublicRequest,
        fetchPublicRequest,
    };
};
